// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WtBV","question":"styles_question__2lpcW","description":"styles_description__3WNTu"};